'use strict';

/**
 * @classname Header
 * @classdesc ヘッダースクロール制御・固定CTAボタン表示制御
 */
export default class Header {
	/**
	 * @constructor
	 * @param {jQuery} $e - #header-kv
	 * @param {Controller} Controller
	 */
	constructor($e, Controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$kv = $e;
		this._$headerKv = $('#header-kv');
		this._$headerFixed = $('#header-fixed');
		this._$headerSp = $('#header-sp');
		this._$headerSpCta = $('#header-sp .header__cta-bar');
		this._$ctaFixed = $('#cta-fixed');
		this._$footer = $('footer');

		if (!this._$kv.length) return;

		// 未対応ブラウザは従来どおりスクロール時に位置を計測する
		if (!('IntersectionObserver' in window)) {
			$(window).on('scroll', () => this.onScroll());
			this.onScroll();
			return;
		}

		// KV・フッターが画面に入っているかをブラウザから通知してもらい、位置計測（強制リフロー）を避ける
		this._isKvVisible = true;
		this._isFooterVisible = false;
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.target === this._$kv[0]) this._isKvVisible = entry.isIntersecting;
				if (this._$footer.length && entry.target === this._$footer[0]) this._isFooterVisible = entry.isIntersecting;
			});
			this.update(this._isKvVisible, this._isFooterVisible);
		});
		observer.observe(this._$kv[0]);
		if (this._$footer.length) observer.observe(this._$footer[0]);
	};


	/**
	 * scrollのコールバック（IntersectionObserver未対応ブラウザ用）
	 *
	 * @memberof Header
	 * @return undefined
	 */
	onScroll() {
		const kvBottom = this._$kv[0].getBoundingClientRect().bottom;
		const isKvVisible = kvBottom > 0;
		const isFooterVisible = this._$footer.length ? this._$footer[0].getBoundingClientRect().top < $(window).innerHeight() : false;
		this.update(isKvVisible, isFooterVisible);
	};


	/**
	 * ヘッダー・固定CTAの表示を切り替える
	 *
	 * @memberof Header
	 * @param {boolean} isKvVisible
	 * @param {boolean} isFooterVisible
	 * @return undefined
	 */
	update(isKvVisible, isFooterVisible) {
		const showCta = !isKvVisible && !isFooterVisible;

		this._$headerKv.toggleClass('is-hidden', !isKvVisible);
		this._$headerFixed.toggleClass('is-visible', !isKvVisible);
		this._$headerFixed.toggleClass('is-footer-visible', isFooterVisible);
		this._$headerSp.toggleClass('is-visible', !isKvVisible);
		this._$headerSpCta.toggleClass('is-visible', !isKvVisible);
		this._$ctaFixed.toggleClass('is-visible', showCta);
	};
};
